import axios from 'axios';

import { digestMessage, generateRandomId, getCookie } from '@/components/tracking_third_party/utils/fbcap.utils';
import { TmCart } from '@/tscapi/model/cart';
import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';
import { Cookie } from '@/tscapi/utils/cookie';
import { getApiBaseUrl } from '@/tscapi/utils/utils';
declare global {
    interface Window {
        ttq: any;
        fbq: any;
        _fbq: any;
    }
}

type TiktokObject = {
    event_source: string;
    event_source_id: string; //pixel_code
    test_event_code?: string;
    data: {
        event: string;
        event_time: string;
        event_id?: string; //orderId
        user: {
            ttclid: string; //hashed click id
            email?: string; //hashed email
            phone?: string;
            external_id?: string; //edpno
            ttp: string; // _ttp cookie
            ip: string;
            user_agent: string;
            locale: string;
        };
        page: {
            url: string;
            referrer: string;
        };
    }[];
};

type EventData = {
    cart: TmCart;
    eventId: string;
};

document.addEventListener(
    'checkoutEvent',
    function (e: CustomEvent) {
        ttInitiateCheckoutEvent(e?.detail);
    },
    false,
);

async function ttInitiateCheckoutEvent(eventDetails: EventData) {
    //if consent is not given, prevent fb event
    if (isConsentCategoryDisabled('targeting')) {
        return;
    }

    const url = getApiBaseUrl();
    const randomEventNumber = generateRandomId(15);
    const tiktokObject = await generateTiktokObject(eventDetails, randomEventNumber);
    const ttObject = JSON.parse(JSON.stringify(tiktokObject));
    tiktokObject[0].eventData.data[0].event_id = randomEventNumber;

    const axiosInstance = axios.create({
        baseURL: url,
        withCredentials: true,
        headers: {
            Authorization: 'Basic 567e407f-4bc5-463e-9c28-3ac2a2b333ec',
            'Content-Type': 'application/json',
        },
    });

    // server event
    if (window.tscConfig?.CapiEnabled == 'true') {
        try {
            await axiosInstance.post('/tracking/v1/events/', tiktokObject);
        } catch (error) {
            console.log('Error sending TT initiatecheckout server event:', error?.response?.data || error.message);
        }
    }

    // pixel event
    try {
        window.ttq.track('InitiateCheckout', ttObject[0].eventData.data[0], {
            event_id: randomEventNumber,
        });
    } catch (e) {
        console.log('Error sending TT initiatecheckout pixel event');
    }
}

async function generateTiktokObject(eventData: EventData, randomEventNumber) {
    const ttclid = getCookie('ttclid'); // TikTok Click ID
    const ttp = getCookie('_ttp'); //Cookie i
    const cookie = new Cookie();
    const tiktokObject: TiktokObject = {
        event_source: 'web',
        event_source_id: 'C8AKQ23G5HF9JD2HK3O0', //tt pixel code
        data: [
            {
                event: 'InitiateCheckout',
                // event_id: randomEventNumber,
                event_time: Math.floor(Date.now() / 1000).toString(),
                user: {
                    ttclid: ttclid ?? '',
                    ttp: ttp,
                    ip: cookie?.TscClientIP ?? '',
                    user_agent: window.navigator.userAgent || '',
                    locale: cookie?.Language.replace('_', '-'), // Modified BCP 47 language identifier
                },
                page: {
                    url: window.location.href,
                    referrer: window.location.host,
                },
            },
        ],
    };
    // If user is signed in, add user data
    if (cookie.UserAccessToken?.Token?.length > 0 && cookie.UserAccessToken.Edp > 0) {
        if (cookie.UserEmail) {
            tiktokObject.data[0].user.email = await digestMessage(cookie.UserEmail.toLowerCase());
        }
        if (eventData?.cart?.Buyer?.BillingAddress?.DayPhone) {
            tiktokObject.data[0].user.phone = await digestMessage(
                eventData?.cart?.Buyer?.BillingAddress?.DayPhone.toLowerCase(),
            );
        }
        if (eventData?.cart?.Buyer?.CustomerNo.toString()) {
            tiktokObject.data[0].user.external_id = await digestMessage(eventData.cart.Buyer.CustomerNo.toString());
        }
    }
    //add test code if exits
    if (window.tscConfig?.TiktokTestCode) {
        tiktokObject.test_event_code = window.tscConfig.TiktokTestCode;
    }

    return [{ eventConsumer: 'tiktok', eventData: { ...tiktokObject } }];
}
